import React, {useState, useEffect}from 'react';
import Select from "react-select";
import {findObjInArr} from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';

const AnchayListComponent = ({onChange, anchay_fk, coquan_fk,tableName,id_tableName, path_access}) => {
    
    const [listAnchay, setListAnchay] = useState([]);

      useEffect(async () => {
            
            const cqtemp = await mainService.getAllAnchay({ path_access : path_access,tableName: tableName,id_tableName: id_tableName });
            setListAnchay(cqtemp);

        }, []);

    return  <>
                                        <label>Ăn chay</label>
                                        <Select
                                            isClearable
                                            name="anchay_fk"
                                            onChange={onChange}
                                            value={findObjInArr(listAnchay, anchay_fk)}
                                            options={listAnchay}
                                        />
                                       
                                    </>
};

export default AnchayListComponent;
